/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/react";
import Box from "@mui/material/Box";
import { RING_SIZE } from "../lib/constants.js";

const rotate = (direction) => keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(${direction}360deg);
  }
`;

const styles = css`
  height: ${RING_SIZE}px;

  .stroke,
  .inner,
  .outer,
  .border {
    fill: none;
    stroke: rgb(var(--color-tertiary), 0.2);
    stroke-width: 42;
    stroke-miterlimit: 10;
    transform-origin: 50% 50%;
  }

  .stroke {
    animation: ${rotate("")} 100s linear infinite;
    stroke-dasharray: 12.1947, 12.1947, 12.1947, 12.1947, 12.1947, 12.1947;
  }

  .inner {
    animation: ${rotate("")} 40s linear infinite;
    stroke-dasharray: 50, 90, 200, 30, 40, 0;
  }

  .outer {
    animation: ${rotate("-")} 50s linear infinite;
    stroke-dasharray: 120, 20, 110, 20, 140;
    stroke-linecap: square;
  }

  .border {
    stroke-linecap: square;
    stroke-width: 16;
  }
`;

export default function RingBackground() {
  return (
    <Box sx={{ zIndex: -1 }}>
      <svg
        css={styles}
        version="1.1"
        viewBox="0 0 1000 1000"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <circle className="stroke" cx="500" cy="500" r="304" />
        <circle className="inner" cx="500" cy="500" r="236" />
        <circle className="outer" cx="500" cy="500" r="366" />
        <circle className="border" cx="500" cy="500" r="410" />
      </svg>
    </Box>
  );
}
